import React from 'react';

/* Company svg */
export const AboutIcon = () => (
  <svg
    style={{ width: '100%', height: '100%' }}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="7.5" fill="#0080CC" />
    <path
      d="M15.5776 11.4746H32.4233C32.7507 11.4747 33.0145 11.5833 33.2299 11.7988C33.4456 12.0143 33.5541 12.2789 33.5541 12.6064V35.3936C33.5541 35.6802 33.4713 35.9188 33.3061 36.1182L33.2299 36.2012C33.0145 36.4167 32.7507 36.5253 32.4233 36.5254H26.2153V30.583H21.7846V36.5254H15.5776C15.2907 36.5254 15.0524 36.4418 14.853 36.2764L14.77 36.2012L14.6948 36.1182C14.5293 35.9188 14.4457 35.6804 14.4457 35.3936V12.6064C14.4457 12.2789 14.5543 12.0143 14.77 11.7988C14.9854 11.5832 15.25 11.4746 15.5776 11.4746ZM16.2465 34.7246H19.9848V28.7832H28.0151V34.7246H31.7543V13.2754H16.2465V34.7246ZM28.0151 22.8984V25.0439H25.8696V22.8984H28.0151ZM22.1303 22.8984V25.0439H19.9848V22.8984H22.1303ZM28.0151 17.0137V19.1592H25.8696V17.0137H28.0151ZM22.1303 17.0137V19.1592H19.9848V17.0137H22.1303Z"
      fill="#FAFBFD"
      stroke="#0080CC"
      strokeWidth="0.45"
    />
  </svg>
);

export const BlogIcon = () => (
  <svg
    style={{ width: '100%', height: '100%' }}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="7.5" fill="#0080CC" />
    <path
      d="M14.7694 33.9922C14.194 33.9922 13.7135 33.7995 13.3281 33.4141C12.9427 33.0287 12.75 32.5482 12.75 31.9728V16.0116C12.75 15.4361 12.9427 14.9557 13.3281 14.5703C13.7135 14.1849 14.194 13.9922 14.7694 13.9922H33.2306C33.806 13.9922 34.2865 14.1849 34.6719 14.5703C35.0573 14.9557 35.25 15.4361 35.25 16.0116V31.9728C35.25 32.5482 35.0573 33.0287 34.6719 33.4141C34.2865 33.7995 33.806 33.9922 33.2306 33.9922H14.7694ZM14.7694 32.7422H33.2306C33.4231 32.7422 33.5995 32.6621 33.7597 32.5019C33.9199 32.3417 34 32.1653 34 31.9728V16.0116C34 15.8191 33.9199 15.6427 33.7597 15.4825C33.5995 15.3223 33.4231 15.2422 33.2306 15.2422H14.7694C14.5769 15.2422 14.4005 15.3223 14.2403 15.4825C14.0801 15.6427 14 15.8191 14 16.0116V31.9728C14 32.1653 14.0801 32.3417 14.2403 32.5019C14.4005 32.6621 14.5769 32.7422 14.7694 32.7422ZM18.0866 29.2806H29.9134C30.0914 29.2806 30.24 29.2209 30.3594 29.1016C30.4788 28.9822 30.5384 28.8335 30.5384 28.6556C30.5384 28.4777 30.4788 28.3291 30.3594 28.2097C30.24 28.0903 30.0914 28.0306 29.9134 28.0306H18.0866C17.9086 28.0306 17.76 28.0903 17.6406 28.2097C17.5213 28.3291 17.4616 28.4777 17.4616 28.6556C17.4616 28.8335 17.5213 28.9822 17.6406 29.1016C17.76 29.2209 17.9086 29.2806 18.0866 29.2806ZM18.0866 24.6172H21.0672C21.2451 24.6172 21.3938 24.5575 21.5131 24.4381C21.6325 24.3188 21.6922 24.1701 21.6922 23.9922V19.3288C21.6922 19.1508 21.6325 19.0022 21.5131 18.8828C21.3938 18.7634 21.2451 18.7038 21.0672 18.7038H18.0866C17.9086 18.7038 17.76 18.7634 17.6406 18.8828C17.5213 19.0022 17.4616 19.1508 17.4616 19.3288V23.9922C17.4616 24.1701 17.5213 24.3188 17.6406 24.4381C17.76 24.5575 17.9086 24.6172 18.0866 24.6172ZM25.2981 24.6172H29.9134C30.0914 24.6172 30.24 24.5575 30.3594 24.4381C30.4788 24.3188 30.5384 24.1701 30.5384 23.9922C30.5384 23.8143 30.4788 23.6656 30.3594 23.5463C30.24 23.4269 30.0914 23.3672 29.9134 23.3672H25.2981C25.1202 23.3672 24.9716 23.4269 24.8522 23.5463C24.7328 23.6656 24.6731 23.8143 24.6731 23.9922C24.6731 24.1701 24.7328 24.3188 24.8522 24.4381C24.9716 24.5575 25.1202 24.6172 25.2981 24.6172ZM25.2981 19.9538H29.9134C30.0914 19.9538 30.24 19.8941 30.3594 19.7747C30.4788 19.6553 30.5384 19.5067 30.5384 19.3288C30.5384 19.1508 30.4788 19.0022 30.3594 18.8828C30.24 18.7634 30.0914 18.7038 29.9134 18.7038H25.2981C25.1202 18.7038 24.9716 18.7634 24.8522 18.8828C24.7328 19.0022 24.6731 19.1508 24.6731 19.3288C24.6731 19.5067 24.7328 19.6553 24.8522 19.7747C24.9716 19.8941 25.1202 19.9538 25.2981 19.9538Z"
      fill="#FAFBFD"
    />
  </svg>
);

export const EventIcon = () => (
  <svg
    style={{ width: '100%', height: '100%' }}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="7.5" fill="#0080CC" />
    <path
      d="M16.0116 35.2728C15.4361 35.2728 14.9557 35.0801 14.5703 34.6947C14.1849 34.3093 13.9922 33.8289 13.9922 33.2534V17.2922C13.9922 16.7168 14.1849 16.2364 14.5703 15.8509C14.9557 15.4655 15.4361 15.2728 16.0116 15.2728H18.2228V13.1575C18.2228 12.9635 18.2866 12.8028 18.4141 12.6753C18.5416 12.548 18.7022 12.4844 18.8959 12.4844C19.0899 12.4844 19.2506 12.548 19.3781 12.6753C19.5054 12.8028 19.5691 12.9635 19.5691 13.1575V15.2728H28.5116V13.1094C28.5116 12.9315 28.5712 12.7828 28.6906 12.6634C28.81 12.5441 28.9586 12.4844 29.1366 12.4844C29.3143 12.4844 29.4628 12.5441 29.5822 12.6634C29.7018 12.7828 29.7616 12.9315 29.7616 13.1094V15.2728H31.9728C32.5482 15.2728 33.0286 15.4655 33.4141 15.8509C33.7995 16.2364 33.9922 16.7168 33.9922 17.2922V33.2534C33.9922 33.8289 33.7995 34.3093 33.4141 34.6947C33.0286 35.0801 32.5482 35.2728 31.9728 35.2728H16.0116ZM16.0116 34.0228H31.9728C32.1653 34.0228 32.3417 33.9427 32.5019 33.7825C32.6621 33.6223 32.7422 33.4459 32.7422 33.2534V22.2922H15.2422V33.2534C15.2422 33.4459 15.3223 33.6223 15.4825 33.7825C15.6427 33.9427 15.8191 34.0228 16.0116 34.0228ZM15.2422 21.0419H32.7422V17.2922C32.7422 17.0997 32.6621 16.9233 32.5019 16.7631C32.3417 16.6029 32.1653 16.5228 31.9728 16.5228H16.0116C15.8191 16.5228 15.6427 16.6029 15.4825 16.7631C15.3223 16.9233 15.2422 17.0997 15.2422 17.2922V21.0419ZM23.9922 26.715C23.7343 26.715 23.5095 26.6193 23.3178 26.4278C23.1264 26.2364 23.0306 26.0116 23.0306 25.7534C23.0306 25.4955 23.1264 25.2708 23.3178 25.0794C23.5095 24.8879 23.7343 24.7922 23.9922 24.7922C24.2501 24.7922 24.4749 24.8879 24.6666 25.0794C24.858 25.2708 24.9537 25.4955 24.9537 25.7534C24.9537 26.0116 24.858 26.2364 24.6666 26.4278C24.4749 26.6193 24.2501 26.715 23.9922 26.715ZM18.9922 26.715C18.7343 26.715 18.5095 26.6193 18.3178 26.4278C18.1264 26.2364 18.0306 26.0116 18.0306 25.7534C18.0306 25.4955 18.1264 25.2708 18.3178 25.0794C18.5095 24.8879 18.7343 24.7922 18.9922 24.7922C19.2501 24.7922 19.4749 24.8879 19.6666 25.0794C19.858 25.2708 19.9537 25.4955 19.9537 25.7534C19.9537 26.0116 19.858 26.2364 19.6666 26.4278C19.4749 26.6193 19.2501 26.715 18.9922 26.715ZM28.9922 26.715C28.7343 26.715 28.5095 26.6193 28.3178 26.4278C28.1263 26.2364 28.0306 26.0116 28.0306 25.7534C28.0306 25.4955 28.1263 25.2708 28.3178 25.0794C28.5095 24.8879 28.7343 24.7922 28.9922 24.7922C29.2501 24.7922 29.4749 24.8879 29.6666 25.0794C29.858 25.2708 29.9537 25.4955 29.9537 25.7534C29.9537 26.0116 29.858 26.2364 29.6666 26.4278C29.4749 26.6193 29.2501 26.715 28.9922 26.715ZM23.9922 31.5228C23.7343 31.5228 23.5095 31.4271 23.3178 31.2356C23.1264 31.0442 23.0306 30.8194 23.0306 30.5613C23.0306 30.3033 23.1264 30.0785 23.3178 29.8869C23.5095 29.6954 23.7343 29.5997 23.9922 29.5997C24.2501 29.5997 24.4749 29.6954 24.6666 29.8869C24.858 30.0785 24.9537 30.3033 24.9537 30.5613C24.9537 30.8194 24.858 31.0442 24.6666 31.2356C24.4749 31.4271 24.2501 31.5228 23.9922 31.5228ZM18.9922 31.5228C18.7343 31.5228 18.5095 31.4271 18.3178 31.2356C18.1264 31.0442 18.0306 30.8194 18.0306 30.5613C18.0306 30.3033 18.1264 30.0785 18.3178 29.8869C18.5095 29.6954 18.7343 29.5997 18.9922 29.5997C19.2501 29.5997 19.4749 29.6954 19.6666 29.8869C19.858 30.0785 19.9537 30.3033 19.9537 30.5613C19.9537 30.8194 19.858 31.0442 19.6666 31.2356C19.4749 31.4271 19.2501 31.5228 18.9922 31.5228ZM28.9922 31.5228C28.7343 31.5228 28.5095 31.4271 28.3178 31.2356C28.1263 31.0442 28.0306 30.8194 28.0306 30.5613C28.0306 30.3033 28.1263 30.0785 28.3178 29.8869C28.5095 29.6954 28.7343 29.5997 28.9922 29.5997C29.2501 29.5997 29.4749 29.6954 29.6666 29.8869C29.858 30.0785 29.9537 30.3033 29.9537 30.5613C29.9537 30.8194 29.858 31.0442 29.6666 31.2356C29.4749 31.4271 29.2501 31.5228 28.9922 31.5228Z"
      fill="#FAFBFD"
    />
  </svg>
);

/* Product svg */
export const DeepFieldSRIcon = () => (
  <svg
    style={{ width: '100%', height: '100%' }}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="7.5" fill="#0080CC" />
    <use xlinkHref="#arrow-grow-icon" />
    <path
      d="M22.752 29.1875V32.5625C22.752 35.375 21.627 36.5 18.8145 36.5H15.4395C12.627 36.5 11.502 35.375 11.502 32.5625V29.1875C11.502 26.375 12.627 25.25 15.4395 25.25H18.8145C21.627 25.25 22.752 26.375 22.752 29.1875Z"
      stroke="#FAFBFD"
      strokeWidth="1.0575"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M19.3389 30.0908C19.9899 30.4667 19.9898 31.4064 19.3389 31.7822L16.6523 33.333C16.0013 33.7089 15.1875 33.239 15.1875 32.4873V29.3857C15.1875 28.634 16.0013 28.1642 16.6523 28.54L19.3389 30.0908Z"
      stroke="#ffffff"
      strokeWidth="1.0575"
      style={{ transformOrigin: 'center', transformBox: 'fill-box' }}
    >
      <animateTransform
        attributeName="transform"
        fill="freeze"
        attributeType="XML"
        type="scale"
        values="0.95 1;1.2 1;0.95 1"
        keyTimes="0;0.5;1"
        keySplines="0.2 0 0.2 1;0.2 0 0.2 1"
        calcMode="spline"
        dur="2s"
        begin="0s"
        repeatCount="indefinite"
      />
    </path>
    <use xlinkHref="#most-outline-path" />
  </svg>
);

export const DeepFieldPQOIcon = () => (
  <svg
    style={{ width: '100%', height: '100%' }}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="7.5" fill="#0080CC" />
    <path
      d="M20.2505 11.5C14.0005 11.5 11.5005 14 11.5005 20.25"
      stroke="#FAFBFD"
      strokeWidth="1.0575"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.6191 11.5C33.8691 11.5 36.3691 14 36.3691 20.25"
      stroke="#FAFBFD"
      strokeWidth="1.0575"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.6191 36.3672C33.8691 36.3672 36.3691 33.8672 36.3691 27.6172"
      stroke="#FAFBFD"
      strokeWidth="1.0575"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.2505 36.3672C14.0005 36.3672 11.5005 33.8672 11.5005 27.6172"
      stroke="#FAFBFD"
      strokeWidth="1.0575"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.0518 11.0156V18.5156L26.565 16.0156 M24.0513 18.5156L21.5381 16.0156"
      stroke="#FAFBFD"
      strokeWidth="1.0575"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ transformOrigin: 'top' }}
    >
      <animateTransform
        attributeName="transform"
        fill="freeze"
        type="translate"
        attributeType="XML"
        values="0 -2;0 1;0 -2"
        begin="0s"
        dur="2s"
        keySplines="0.2 0 0.2 1;0.2 0 0.2 1"
        calcMode="spline"
        repeatCount="indefinite"
      />
    </path>
    <path
      d="M24.0518 36.875V29.375L26.565 31.875 M24.0513 29.375L21.5381 31.875"
      stroke="#FAFBFD"
      strokeWidth="1.0575"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ transformOrigin: 'bottom' }}
    >
      <animateTransform
        attributeName="transform"
        fill="freeze"
        type="translate"
        attributeType="XML"
        values="0 2;0 -1;0 2"
        begin="0s"
        dur="2s"
        keySplines="0.2 0 0.2 1;0.2 0 0.2 1"
        calcMode="spline"
        repeatCount="indefinite"
      />
    </path>
    <path
      d="M9.89551 24.0547H17.3955L14.8955 26.5679 M17.3965 24.0523L14.8965 21.5391"
      stroke="#FAFBFD"
      strokeWidth="1.0575"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ transformOrigin: 'bottom' }}
    >
      <animateTransform
        attributeName="transform"
        fill="freeze"
        type="translate"
        attributeType="XML"
        values="2 0;-1 0;2 0"
        begin="0s"
        dur="2s"
        keySplines="0.2 0 0.2 1;0.2 0 0.2 1"
        calcMode="spline"
        repeatCount="indefinite"
      />
    </path>
    <path
      d="M38.2158 24.0547H30.7158L33.2158 26.5679 M30.7163 24.0523L33.2163 21.5391"
      stroke="#FAFBFD"
      strokeWidth="1.0575"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ transformOrigin: 'right' }}
    >
      <animateTransform
        attributeName="transform"
        fill="freeze"
        type="translate"
        attributeType="XML"
        values="-2 0;1 0;-2 0"
        begin="0s"
        dur="2s"
        keySplines="0.2 0 0.2 1;0.2 0 0.2 1"
        calcMode="spline"
        repeatCount="indefinite"
      />
    </path>
  </svg>
);

export const CommonDEFS = () => {
  return (
    <svg id="common-defs" style={{ position: 'absolute' }}>
      <defs>
        <g opacity="0">
          <animate
            attributeName="opacity"
            id="reset-anim"
            values="0;1"
            begin="outline-path-anim.end+0s"
            dur="2s"
          />
        </g>
        <path
          id="arrow-grow-icon"
          d="M25.248 22.7516L31.5105 16.4766H26.498 M31.5117 16.4766V21.4891"
          stroke="#FAFBFD"
          strokeWidth="1.0575"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ transformOrigin: 'bottom left', transformBox: 'fill-box' }}
        >
          <animateTransform
            id="arrow-path-anim"
            attributeName="transform"
            type="scale"
            begin="0;reset-anim.end+0s"
            values="0;0.99;1"
            keyTimes="0;0.8;1"
            keySplines="0.2 0 0.2 1; 0 0 0.58 1"
            calcMode="spline"
            dur="0.9s"
            fill="freeze"
          />
        </path>

        {/* 최외곽 선 */}
        <path
          id="most-outline-path"
          d="M27.7129 36.4609C33.9629 36.4609 36.4629 33.961 36.4629 27.711V20.211C36.4629 13.961 33.9629 11.461 27.7129 11.461H20.2129C13.9629 11.461 11.4629 13.961 11.4629 20.211L11.4629 21.3118"
          stroke="#FAFBFD"
          strokeWidth="1.0575"
          strokeLinecap="round"
          strokeLinejoin="round"
          opacity="0"
          pathLength="1"
          strokeDasharray="1"
          strokeDashoffset="1"
          style={{ transformOrigin: 'bottom left', transformBox: 'fill-box' }}
        >
          <animate
            id="outline-path-anim"
            attributeName="stroke-dashoffset"
            from="1"
            to="0"
            dur="0.7s"
            begin="arrow-path-anim.end + 0.12s"
            calcMode="spline"
            keySplines="0.22 0 0.2 1"
            fill="freeze"
          />
          <animate
            attributeName="opacity"
            from="0"
            to="1"
            dur="0.3s"
            begin="arrow-path-anim.end + 0.12s"
            calcMode="spline"
            keySplines="0 0 0.58 1"
            fill="freeze"
          />
          <animate
            id="remove-path-anim"
            attributeName="opacity"
            from="1"
            to="0"
            dur="0.3s"
            begin="outline-path-anim.end+1.8s"
            calcMode="spline"
            keySplines="0.22 0 0.2 1"
            fill="freeze"
          />
        </path>
      </defs>
    </svg>
  );
};

export const PulsarAV1Icon = () => (
  <svg
    style={{ width: '100%', height: '100%' }}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="7.5" fill="#0080CC" />

    {/* 화살표 하 */}
    <path
      d="M37.2171 37.6484L30.9421 31.3859V36.3984 M30.9421 31.3906H35.9546"
      stroke="#FAFBFD"
      strokeWidth="1.0575"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ transformOrigin: 'bottom right', transformBox: 'fill-box' }}
    >
      <animateTransform
        attributeName="transform"
        type="translate"
        values="0 0;-3 -3; -0.5 -0.5; 0 0"
        keyTimes="0; 0.15; 0.95; 1"
        calcMode="spline"
        keySplines="0.2 0 0.2 1; 0.2 0 0.2 1; 0.2 0 0.2 1"
        dur="2.5s"
        repeatCount="indefinite"
      />
    </path>

    {/* 화살표 상 */}
    <path
      d="M10.7924 10.3438L17.0674 16.6063V11.5938 M17.0674 16.6094H12.0549"
      stroke="#FAFBFD"
      strokeWidth="1.0575"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ transformOrigin: 'top left', transformBox: 'fill-box' }}
    >
      <animateTransform
        attributeName="transform"
        type="translate"
        values="0 0;3 3; 0.5 0.5; 0 0"
        keyTimes="0; 0.15; 0.95; 1"
        calcMode="spline"
        keySplines="0.2 0 0.2 1; 0.2 0 0.2 1; 0.2 0 0.2 1"
        dur="2.5s"
        repeatCount="indefinite"
      />
    </path>

    <path
      d="M20.9653 10.4297H28.4653C34.7153 10.4297 37.2153 12.9297 37.2153 19.1797V26.6797"
      stroke="#FAFBFD"
      strokeWidth="1.0575"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.1421 37.6484H19.6421C13.3921 37.6484 10.8921 35.1484 10.8921 28.8984V21.3984"
      stroke="#FAFBFD"
      strokeWidth="1.0575"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* play icon */}
    <path
      d="M28.4102 23.1172C28.9089 23.5038 28.9087 24.2685 28.4102 24.6553L28.2959 24.7324L22.7549 27.9316C22.104 28.3073 21.2903 27.8374 21.29 27.0859V20.6875C21.29 19.9358 22.1039 19.4659 22.7549 19.8418L28.2959 23.041L28.4102 23.1172Z"
      stroke="#FAFBFD"
      strokeWidth="1.0575"
      style={{ transformOrigin: 'top left', transformBox: 'fill-box' }}
    >
      <animateTransform
        attributeName="transform"
        type="scale"
        values="1 1; 0.75 0.75; 1.02 1.02; 1 1"
        keyTimes="0; 0.15; 0.95; 1"
        calcMode="spline"
        keySplines="0.2 0 0.2 1; 0.2 0 0.2 1; 0.2 0 0.2 1"
        dur="2.5s"
        repeatCount="indefinite"
      />
    </path>
  </svg>
);

export const PulsarAVIFIcon = () => (
  <svg
    style={{ width: '100%', height: '100%' }}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="7.5" fill="#0080CC" />
    {/* 화살표 하 */}
    <path
      d="M37.2164 37.6484L30.9414 31.3859V36.3984 M30.9414 31.3906H35.9539"
      stroke="#FAFBFD"
      strokeWidth="1.0575"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ transformOrigin: 'bottom right', transformBox: 'fill-box' }}
    >
      <animateTransform
        attributeName="transform"
        type="translate"
        values="0 0;-3 -3; -0.5 -0.5; 0 0"
        keyTimes="0; 0.15; 0.95; 1"
        calcMode="spline"
        keySplines="0.2 0 0.2 1; 0.2 0 0.2 1; 0.2 0 0.2 1"
        dur="2.5s"
        repeatCount="indefinite"
      />
    </path>

    <g
      id="mount-sun"
      style={{ transformOrigin: 'center', transformBox: 'fill-box' }}
      vectorEffect="non-scaling-stroke"
    >
      {/* 원 */}
      <path
        d="M23.145 23.3438C24.5257 23.3438 25.645 22.2245 25.645 20.8438C25.645 19.463 24.5257 18.3438 23.145 18.3438C21.7643 18.3438 20.645 19.463 20.645 20.8438C20.645 22.2245 21.7643 23.3438 23.145 23.3438Z"
        stroke="#FAFBFD"
        strokeWidth="1.0575"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* 산 */}
      <path
        d="M11.2026 32.5065L17.7691 27.1772C18.8213 26.3239 20.3397 26.4205 21.2854 27.4026L21.7249 27.8695C22.7638 28.9483 24.4421 28.9483 25.481 27.8695L31.0218 22.1216C32.0607 21.0428 33.7389 21.0428 34.7779 22.1216L36.9489 24.3757"
        stroke="#FAFBFD"
        strokeWidth="1.0575"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <animateTransform
        attributeName="transform"
        type="scale"
        values="1 1; 0.55 0.65; 1.02 1.01; 1 1"
        keyTimes="0; 0.15; 0.95; 1"
        calcMode="spline"
        keySplines="0.2 0 0.2 1; 0.2 0 0.2 1; 0.2 0 0.2 1"
        dur="2.5s"
        repeatCount="indefinite"
      />
    </g>

    {/* 화살표 상 */}
    <path
      d="M10.7924 10.3438L17.0674 16.6063V11.5938 M17.0674 16.6016H12.0549"
      stroke="#FAFBFD"
      strokeWidth="1.0575"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ transformOrigin: 'top left', transformBox: 'fill-box' }}
    >
      <animateTransform
        attributeName="transform"
        type="translate"
        values="0 0;3 3; 0.5 0.5; 0 0"
        keyTimes="0; 0.15; 0.95; 1"
        calcMode="spline"
        keySplines="0.2 0 0.2 1; 0.2 0 0.2 1; 0.2 0 0.2 1"
        dur="2.5s"
        repeatCount="indefinite"
      />
    </path>

    <path
      d="M27.0425 37.5625H19.5425C13.2925 37.5625 10.7925 35.0625 10.7925 28.8125V21.3125"
      stroke="#FAFBFD"
      strokeWidth="1.0575"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.8657 10.3438H28.3657C34.6157 10.3438 37.1157 12.8438 37.1157 19.0938V26.5938"
      stroke="#FAFBFD"
      strokeWidth="1.0575"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PulsarVQMIcon = () => (
  <svg
    style={{ width: '100%', height: '100%' }}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="7.5" fill="#0080CC" />

    <g opacity={0}>
      <animate
        attributeName="opacity"
        id="vqm-reset-anim"
        values="0;0"
        dur="2s"
        begin="arrow-head-anim.end+0"
      />
    </g>

    {/* 최외곽 */}
    <path
      d="M20.3068 36.9352H28.017C34.4422 36.9352 37.0123 34.3651 37.0123 27.9399V20.2297C37.0123 13.8045 34.4422 11.2344 28.017 11.2344H20.3068C13.8816 11.2344 11.3115 13.8045 11.3115 20.2297V27.9399C11.3115 34.3651 13.8816 36.9352 20.3068 36.9352Z"
      stroke="#FAFBFD"
      strokeWidth="1.0575"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M30.0585 17.7689C28.6751 16.3563 27.1829 15.6666 25.3728 15.3547M17.4878 17.8095C15.6775 19.5825 14.7688 21.9287 14.7674 24.277M17.4878 17.8095L20.1788 20.5571M17.4878 17.8095C19.6497 15.6921 22.6023 14.8772 25.3728 15.3547M19.2055 28.4141L17.6519 30.2661C17.4926 30.456 17.2035 30.4676 17.0392 30.282C15.5219 28.5686 14.7662 26.4219 14.7674 24.277M14.7674 24.277L18.1992 24.3127M25.3728 15.3547L25.123 19.1925"
      stroke="#FAFBFD"
      strokeWidth="1.0575"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <g>
      {/* 초침 중심 */}
      <path
        d="M23.4124 24.0061C23.9032 23.8304 24.1587 23.29 23.9829 22.7992C23.8072 22.3083 23.2668 22.0529 22.776 22.2287C22.2851 22.4044 22.0297 22.9448 22.2054 23.4356C22.3812 23.9265 22.9216 24.1819 23.4124 24.0061Z"
        stroke="#FAFBFD"
        strokeWidth="1.0575"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* 초침 중심 하단 */}
      <path
        d="M20.9775 24.4609L22.1848 23.625"
        stroke="#FAFBFD"
        strokeWidth="1.0575"
        strokeLinecap="round"
      />

      {/* 초침 중심 상단 */}
      <path
        d="M23.8267 22.4609L27.1035 20.1919"
        stroke="#FAFBFD"
        strokeWidth="1.0575"
        strokeLinecap="round"
      />
      <animateTransform
        attributeName="transform"
        type="rotate"
        values="-30 23.35 23.95; 40 23.35 23.95; -30 23.35 23.95"
        keyTimes="0;0.5;1"
        calcMode="spline"
        keySplines="0.2 0 0.2 1; 0.2 0 0.2 1"
        dur="2.4s"
        repeatCount="indefinite"
      />
    </g>

    {/* 화살표 꼬리 */}
    <path
      d="M19.6932 33.5318L24.4602 27.4958L30.6472 28.3977L33.7676 23.5669"
      stroke="#FAFBFD"
      strokeWidth="1.0575"
      strokeLinecap="round"
      strokeDasharray="1"
      strokeDashoffset="1"
      pathLength="1"
    >
      <animate
        id="arrow-tail-anim"
        attributeName="stroke-dashoffset"
        dur="1s"
        values="1;0"
        keyTimes="0;1"
        calcMode="spline"
        keySplines="0.22 0 0.2 1"
        fill="freeze"
        begin="0;vqm-reset-anim.end+0"
      />
    </path>

    {/* 화살표 머리 */}
    <path
      d="M31.4468 23.8984L33.8634 23.4596L34.3008 25.868"
      stroke="#FAFBFD"
      strokeWidth="1.0575"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="1"
      strokeDashoffset="1"
      pathLength="1"
    >
      <animate
        id="arrow-head-anim"
        attributeName="stroke-dashoffset"
        values="1;0"
        keyTimes="0;1"
        dur="0.3s"
        begin="arrow-tail-anim.end+0"
        calcMode="spline"
        keySplines="0.22 0 0.2 1"
        fill="freeze"
      />
      <animate
        id="arrow-head-remove-anim"
        attributeName="opacity"
        values="1;0"
        keyTimes="0;1"
        dur="0.3s"
        begin="arrow-tail-anim.end+2.2s"
        calcMode="spline"
        keySplines="0.22 0 0.2 1"
        fill="freeze"
      />
      <animate
        attributeName="opacity"
        values="0;1"
        keyTimes="0;1"
        dur="0.3s"
        begin="arrow-head-remove-anim.end+1s"
        calcMode="spline"
        keySplines="0.22 0 0.2 1"
        fill="freeze"
      />
    </path>
  </svg>
);
